import { CLEAR_MODAL_DATA } from "core-web/state/models/Modal/constants";
import store from "core-web/state/store";

const clearModalData = () => (dispatch) => {
    dispatch({
        type: CLEAR_MODAL_DATA,
    });
};

export default () => store.dispatch(clearModalData());
